module.exports = __webpack_public_path__ + "img/img_7.b4ed2458.jpeg";